(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-course-upsell"]) return;
  try {
    
(() => {
  if (customElements.get('es-course-upsell')) return;
  const nativeFetch = window.fetch.bind(window);
  let pendingWrites = 0;
  let revision = 0;
  const listeners = new Set();
  const notify = () => listeners.forEach(listener => listener());
  const isCartWrite = input => {
    try {
      const url = new URL(input instanceof Request ? input.url : input, location.href);
      return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
    } catch { return false; }
  };
  window.fetch = function (input, options) {
    if (!isCartWrite(input)) return nativeFetch(input, options);
    pendingWrites++;
    revision++;
    notify();
    return nativeFetch(input, options).finally(() => { pendingWrites--; revision++; notify(); });
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  const xhrSend = XMLHttpRequest.prototype.send;
  const trackedXHR = new WeakSet();
  XMLHttpRequest.prototype.open = function (method, url, ...args) {
    trackedXHR.delete(this);
    if (isCartWrite(url)) trackedXHR.add(this);
    return xhrOpen.call(this, method, url, ...args);
  };
  XMLHttpRequest.prototype.send = function (...args) {
    if (!trackedXHR.has(this)) return xhrSend.apply(this, args);
    pendingWrites++; revision++; notify();
    let done = false;
    const finish = () => {
      if (done) return;
      done = true; pendingWrites--; revision++; notify();
    };
    this.addEventListener('loadend', finish, { once: true });
    try { return xhrSend.apply(this, args); } catch (error) { finish(); throw error; }
  };
  class ESCourseUpsell extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.state = this.readState(this);
      if (!this.state.offerId) return;
      this.dialog = this.querySelector('dialog');
      this.button = this.querySelector('[data-es-add]');
      this.error = this.querySelector('[data-es-error]');
      this.notice = this.querySelector('[data-es-notice]');
      this.root = window.Shopify?.routes?.root || '/';
      this.storageKey = `es-course-upsell:${location.hostname}:${this.state.campaign}`;
      this.storageTtl = 24 * 60 * 60 * 1000;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelectorAll('[data-es-close]').forEach(button => button.addEventListener('click', () => this.close(), options));
      this.button.addEventListener('click', () => this.accept(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }, options);
      this.onUpdate = () => { this.version = (this.version || 0) + 1; this.schedule(); };
      listeners.add(this.onUpdate);
      ['cart:updated', 'cart:change', 'cart:refresh', 'cart:open', 'es-upsell:refresh'].forEach(name => document.addEventListener(name, this.onUpdate, options));
      window.addEventListener('pageshow', this.onUpdate, options);
      window.addEventListener('focus', this.onUpdate, options);
      window.addEventListener('storage', event => {
        if (event.key === this.storageKey && this.isRecent(event.newValue)) this.close();
        this.onUpdate();
      }, options);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.onUpdate(); }, options);
      document.addEventListener('submit', event => this.guardSubmit(event), { ...options, capture: true });
      document.addEventListener('click', event => this.guardCheckoutLink(event), { ...options, capture: true });
      this.observer = new MutationObserver(() => {
        const visible = this.cartVisible();
        if (visible !== this.wasVisible) { this.wasVisible = visible; this.schedule(); }
      });
      this.observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'open', 'aria-hidden', 'style'] });
      this.poll = setInterval(() => { if (!document.hidden) this.schedule(); }, 4000);
      this.schedule();
    }
    disconnectedCallback() {
      this.close();
      this.abort?.abort();
      this.observer?.disconnect();
      clearInterval(this.poll);
      clearTimeout(this.timer);
      listeners.delete(this.onUpdate);
      this.initialized = false;
    }
    readState(root) {
      const state = JSON.parse(root.querySelector('[data-es-state]').textContent);
      if (!Array.isArray(state.offerLines) || typeof state.eligible !== 'boolean') throw new Error('Invalid cart state');
      return state;
    }
    cartVisible() {
      if (this.dataset.cartPage === 'true') return true;
      if (location.pathname.replace(/\/$/, '') === this.dataset.cartUrl.replace(/\/$/, '')) return true;
      const selector = this.dataset.drawerSelector;
      if (!selector) return false;
      try {
        return [...document.querySelectorAll(selector)].some(element => {
          const style = getComputedStyle(element);
          return element.getClientRects().length && style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0';
        });
      } catch { return false; }
    }
    isRecent(value) {
      const shownAt = Number(value);
      const age = Date.now() - shownAt;
      return Number.isFinite(shownAt) && shownAt > 0 && age >= 0 && age < this.storageTtl;
    }
    seen() {
      if (this.isRecent(this.shownAt)) return true;
      try { if (this.isRecent(localStorage.getItem(this.storageKey))) return true; } catch {}
      try { return this.isRecent(sessionStorage.getItem(this.storageKey)); } catch { return false; }
    }
    remember() {
      const shownAt = Date.now();
      this.shownAt = shownAt;
      try { localStorage.setItem(this.storageKey, String(shownAt)); } catch {}
      try { sessionStorage.setItem(this.storageKey, String(shownAt)); } catch {}
    }
    async request(url, options = {}) {
      const response = await nativeFetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: AbortSignal.timeout(12000) });
      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
      return response;
    }
    async fresh() {
      for (let attempt = 0; attempt < 5; attempt++) {
        if (pendingWrites) { await new Promise(resolve => setTimeout(resolve, 180)); continue; }
        const currentRevision = revision;
        const url = new URL(this.dataset.cartUrl, location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('_es', Date.now());
        const response = await this.request(url);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const state = this.readState(html);
        if (pendingWrites || currentRevision !== revision) continue;
        this.state = state;
        return state;
      }
      throw new Error('Cart is still updating');
    }
    async post(path, data) {
      revision++;
      const response = await this.request(this.root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
      revision++;
      return response.json();
    }
    async reconcile() {
      const state = await this.fresh();
      if (!state.eligible && state.offerLines.length) {
        this.close();
        await this.post('cart/update.js', { updates: Object.fromEntries(state.offerLines.map(line => [line.key, 0])) });
        const checked = await this.fresh();
        if (!checked.eligible && checked.offerLines.length) throw new Error('Offer removal did not complete');
        location.reload();
        return null;
      }
      if (!state.eligible || state.hasCourse || !state.available) this.close();
      this.notice.hidden = true;
      return state;
    }
    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.sync(), 250);
    }
    async sync() {
      if (this.busy || this.accepting || !this.isConnected) return;
      this.busy = true;
      const version = this.version;
      try {
        const state = await this.reconcile();
        if (state && state.available && state.eligible && !state.hasCourse && this.cartVisible() && !this.seen() && !window.Shopify?.designMode) await this.show();
      } catch {
        if (this.dialog.open) this.close();
        if (this.state.offerLines.length) this.showNotice();
      } finally {
        this.busy = false;
        if (this.version !== version) this.schedule();
      }
    }
    async show() {
      const open = () => {
        if (this.seen() || !this.isConnected || !this.cartVisible() || pendingWrites || !this.dialog.showModal) return;
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.dialog.querySelector('h2').focus({ preventScroll: true });
        this.remember();
      };
      if (navigator.locks) await navigator.locks.request(this.storageKey, open);
      else open();
    }
    close() { if (this.dialog?.open) this.dialog.close(); }
    showNotice() { this.notice.textContent = this.state.messages.checkError; this.notice.hidden = false; }
    async accept() {
      if (this.accepting) return;
      this.accepting = true;
      this.button.disabled = true;
      this.button.textContent = this.state.messages.adding;
      this.error.hidden = true;
      try {
        while (this.busy) await new Promise(resolve => setTimeout(resolve, 100));
        this.busy = true;
        const state = await this.reconcile();
        if (!state) return;
        if (!state.available || !state.eligible || state.hasCourse) {
          this.close();
          this.notice.textContent = state.messages.unavailable;
          this.notice.hidden = false;
          return;
        }
        await this.post('cart/add.js', { items: [{ id: state.variantId, quantity: 1, properties: { _es_course_upsell: state.campaign } }] });
        await this.reconcile();
        location.assign(this.dataset.cartUrl);
      } catch {
        this.error.textContent = this.state.messages.error;
        this.error.hidden = false;
        if (!this.dialog.open) this.showNotice();
      } finally {
        this.busy = false;
        this.accepting = false;
        this.button.disabled = false;
        this.button.textContent = this.state.messages.accept;
        this.schedule();
      }
    }
    async beforeCheckout(resume) {
      if (this.checkingOut) return;
      if (this.busy || this.accepting || pendingWrites) { this.showNotice(); return; }
      this.checkingOut = true;
      this.busy = true;
      try {
        const state = await this.reconcile();
        if (state) { this.close(); resume(); }
      } catch { this.showNotice(); }
      finally { this.busy = false; this.checkingOut = false; }
    }
    guardSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const submitter = event.submitter;
      const action = new URL(form.action || location.href, location.href);
      if (action.origin !== location.origin) return;
      const isCheckout = submitter?.name === 'checkout' || /\/checkout\/?$/.test(action.pathname);
      if (!isCheckout) return;
      if (this.allowedForm === form) { this.allowedForm = null; return; }
      event.preventDefault(); event.stopImmediatePropagation();
      this.beforeCheckout(() => {
        this.allowedForm = form;
        try { form.requestSubmit(submitter || undefined); } finally { this.allowedForm = null; }
      });
    }
    guardCheckoutLink(event) {
      const link = event.target.closest?.('a[href]');
      if (!link || this.allowedLink === link) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      this.beforeCheckout(() => {
        this.allowedLink = link;
        try { link.click(); } finally { this.allowedLink = null; }
      });
    }
  }
  customElements.define('es-course-upsell', ESCourseUpsell);
})();


  } catch(e) { console.error(e); }
})();
})();
